import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { InstructorService } from '../instructor.service';
import { FilterService } from '@core/services/outros/filter.service';
import { InstructorOrganizationsModel } from '@core/models/agendamento-pratico/instructor-organization.model';
import { UserControllerService } from '@core/services/outros/user-controller.service';

@Injectable({
  providedIn: 'root'
})
export class InstructorResolver implements Resolve<Observable<InstructorOrganizationsModel[]>> {

  constructor(
    private _service: InstructorService,
    private _filterService: FilterService,
    private _userControllerService: UserControllerService,
  ) { }

  resolve(): Observable<InstructorOrganizationsModel[]> {
    const user = this._userControllerService.getUserLogged();
    const filter = {IdOrganization: user.organizationId};
    return this._service
      .getAll(filter)
      .pipe(
        map(res => res),
        catchError(
          () => of(new Array<InstructorOrganizationsModel>())
        )
      )
  }
}
